import { postRequest, formDataRequest, getRequest } from "../libs/AxiosService.util";

export async function serviceCreateContactQuick(params) {
  return await postRequest("contacts/create/quickdsa", params);
}

export async function serviceUpdateContact(params) {
  return await postRequest("contacts/update", params);
}
export async function serviceGetContact(params) {
  return await postRequest("contacts", params);
}
export async function serviceGetCustomer(params) {
  return await postRequest("contacts/customers", params);
}


export async function serviceGetContactDetails(params) {
  return await postRequest("contacts/detail", params);
}

export async function serviceCreateContact(params) {
  return await postRequest("contacts/create", params);
}

export async function serviceDeleteContact(params) {
  return await formDataRequest("contacts/delete", params);
}

export async function serviceContactCheck(params) {
  return await postRequest("contacts/check", params);
}

export async function serviceGetKycByPhone(params) {
  return await postRequest("contacts/kyc/by-phone", params);
}

export async function serviceCreateCustomer(params) {
  return await postRequest("contacts/customers/create", params);
}

export async function serviceUpdateStatus(params) {
  return await postRequest("contacts/update/status", params);
}
export async function serviceMarkCustomer(params) {
  return await postRequest("contacts/mark/customer", params);
}
export async function serviceCreateQuery(params) {
  return await postRequest("contacts/customers/query/add", params);
}
export async function serviceQueryList(params) {
  return await postRequest("contacts/customers/query", params);
}
export async function serviceUpdateQueryStatus(params) {
  return await postRequest("leads/update/status", params);
}
export async function serviceUpdateLeadOwner(params) {
  return await postRequest("contacts/update/lead/owner", params);
}
export async function serviceAddEvent(params) {
  return await postRequest("contacts/add/event", params);
}
export async function serviceGetReasonList(params= {}) {
  return await getRequest("contacts/not/interested/reasons", params);
}
export async function serviceGetAppointmentList(params) {
  return await postRequest("appointments/customer/wise", params);
}
export async function serviceGetPaymentLink(params) {
  return await postRequest("payment/generate/link", params);
}
export async function serviceGetStatus(params) {
  return await postRequest("payment/status", params);
}
export async function serviceCreateRecordSale(params) {
  return await postRequest("record/sale/create", params);
}
export async function serviceGetEventLog(params) {
  return await postRequest("contacts/event/logs", params);
}
export async function serviceGetEventLogsQuery(params) {
  return await postRequest("contacts/event/logs/query", params);
}
export async function serviceSendWebsiteLink(params) {
  return await postRequest("contacts/send/website/link", params);
}
export async function serviceDropQuery(params) {
  return await postRequest("contacts/customers/query/drop", params);
}
export async function serviceUpdateQueryTags(params) {
  return await postRequest("leads/update/tags", params);
}

export async function serviceGetContactLeads(params) {
  return await postRequest("contacts/leads", params);
}

export async function serviceGetContactAttachments(params) {
  return await postRequest("leads/attachments/by-contact", params);
}

export async function serviceGetContactQuotations(params) {
  return await postRequest("leads/quotations/by-contact", params);
}